import { createFileRoute } from '@tanstack/react-router'
import CallAnalytics from '@/components/organisms/CallAnalytics'

export const Route = createFileRoute('/_authenticated/phone/analytics')({
  component: CallAnalytics,
})
